var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "aside-actions", style: { width: "100%" } }, [
    _c("div", [
      _vm.showEnquireNowButton
        ? _c("div", { attrs: { "data-test": "enquire_now" } }, [
            _c(
              "button",
              {
                staticClass: "btn--product-aside product-aside-enquire-now",
                attrs: { id: _vm.theId },
                on: { click: _vm.redirectToLink },
              },
              [_vm._v(_vm._s(_vm.enquireNowText))]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }